import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeNavigationContainerSkeleton } from "./TypeNavigationContainer";

/**
 * Fields type definition for content type 'TypeContentPageHeader'
 * @name TypeContentPageHeaderFields
 * @type {TypeContentPageHeaderFields}
 * @memberof TypeContentPageHeader
 */
export interface TypeContentPageHeaderFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized false
     */
    header: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized false
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized false
     */
    description?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'image' (Image)
     * @name Image
     * @localized false
     */
    image?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'tableOfContents' (Table Of Contents)
     * @name Table Of Contents
     * @localized false
     */
    tableOfContents: EntryFieldTypes.Boolean;
    /**
     * Field type definition for field 'navigation' (Navigation)
     * @name Navigation
     * @localized false
     */
    navigation?: EntryFieldTypes.EntryLink<TypeNavigationContainerSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'contentPageHeader' (Content Page Header)
 * @name TypeContentPageHeaderSkeleton
 * @type {TypeContentPageHeaderSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T19:27:55.911Z
 * @version 9
 */
export type TypeContentPageHeaderSkeleton = EntrySkeletonType<TypeContentPageHeaderFields, "contentPageHeader">;
/**
 * Entry type definition for content type 'contentPageHeader' (Content Page Header)
 * @name TypeContentPageHeader
 * @type {TypeContentPageHeader}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T19:27:55.911Z
 * @version 9
 */
export type TypeContentPageHeader<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeContentPageHeaderSkeleton, Modifiers, Locales>;

export function isTypeContentPageHeader<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeContentPageHeader<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'contentPageHeader'
}
